<router-outlet></router-outlet>
<sen-app-loader></sen-app-loader>